export default "__VITE_ASSET__Dy3MjOsE__"